import React from "react";
import { Route, Redirect } from "react-router-dom";
const HybridRoute = ({
    isLoggedIn,
    path,
    exact,
    component: Component,
    name,
}: {
    isLoggedIn: boolean;
    path: string;
    exact: boolean;
    component: React.ComponentType<any>;
    name: string;
}) => {
    return (
        <Route
            path={path}
            exact={exact}
            render={(props) => <Component {...props} />}
        />
    );
};
export default HybridRoute;
